/**
 * HelloRetailAPI
 *
 * Pure API wrapper around the Hello Retail JS SDK (hrq queue).
 * No DOM knowledge, no Shopify-specific rendering.
 * The correct search key is resolved automatically from themeVariables
 * based on the market already established by the Hello Retail init in theme.liquid.
 *
 * Usage:
 *   var api = new HelloRetailAPI();
 *   api.search('jacket', { engine_options: { product: { current_count: 6 } } })
 *     .then(function(data) { console.log(data.results); });
 */

(function () {
  'use strict';

  function HelloRetailAPI() {
    var settings = window.themeVariables && window.themeVariables.settings;
    this.searchKey = settings && settings.hrSearchKey;
  }

  /**
   * Search for products using the Hello Retail JS SDK.
   *
   * @param {string} query      - The search phrase
   * @param {object} [options]  - Overrides merged on top of defaults
   * @returns {Promise}         - Resolves with the raw Hello Retail response object
   */
  HelloRetailAPI.prototype.search = function (query, options) {
    var self = this;
    options = options || {};

    var defaults = {
      format: 'json',
      engine_options: {
        product: { current_count: 6, start: 0 }
      }
    };

    var mergedOptions = Object.assign({}, defaults, options);
    mergedOptions.engine_options = Object.assign(
      {},
      defaults.engine_options,
      options.engine_options || {}
    );
    mergedOptions.engine_options.product = Object.assign(
      {},
      defaults.engine_options.product,
      (options.engine_options && options.engine_options.product) || {}
    );

    return new Promise(function (resolve, reject) {
      if (!self.searchKey) {
        console.warn('[HR API] No search key configured.');
        reject(new Error('Hello Retail search key is not configured. Add it under Theme Settings → Search.'));
        return;
      }

      window.hrq = window.hrq || [];
      window.hrq.push([
        'search',
        self.searchKey,
        query,
        mergedOptions,
        function (results) {
          resolve(results);
        }
      ]);
    });
  };

  /**
   * Load a Hello Retail recommendation by key.
   *
   * @param {string} key  - The Hello Retail recom key
   * @returns {Promise}   - Resolves with the recom object ({ products: [...], ... })
   */
  HelloRetailAPI.prototype.loadRecom = function (key) {
    return new Promise(function (resolve, reject) {
      if (!key) {
        reject(new Error('Hello Retail loadRecom: no key provided.'));
        return;
      }
      window.hrq = window.hrq || [];
      window.hrq.push(['loadRecom', [{ key: key, format: 'json' }], function (responses) {
        var recom = Array.isArray(responses)
          ? responses[0]
          : (responses && responses.responses ? responses.responses[0] : responses);
        resolve(recom);
      }]);
    });
  };

  window.HelloRetailAPI = HelloRetailAPI;
})();
